// @flow
import type { Message } from 'common/modules/notifications/domain/Message';
import NotificationClient from 'common/modules/notifications/services/NotificationClient';
import { getToken } from 'statsradio/modules/authentication/session/reducers/sessionReducer';
import type { Dispatch, GetState } from '../../../types/Store';
import NotificationRouter from './notificationRouter';

export function sendMessage(message: Message) {
  return async (dispatch: Dispatch, getState: GetState) => {
    try {
      NotificationClient.send(message);
    } catch (e) {
      // do nothing
    }
  };
}

export function openNotificationClient() {
  return async (dispatch: Dispatch, getState: GetState) => {
    try {
      const getTokenCallback = () => getToken(getState());
      const router = NotificationRouter.create(dispatch);

      NotificationClient.open(getTokenCallback, router);
    } catch (e) {
      // do nothing
    }
  };
}

export function closeNotificationClient() {
  return async (dispatch: Dispatch, getState: GetState) => {
    NotificationClient.close();
  };
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/notifications/actions/notificationActions.js